import moment from "moment";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import type { Ticket } from "../../../types/models/ticket.model.type";
import type { FilterOptionsMyTickets, MyTicketsState } from "../../../types/states/ticket.state.type";
import { MyTicketsFilterRequest } from "../../../types/request/ticket.request.type";

const initialState: MyTicketsState = {
  isFetching: false,
  data: [],
  error: undefined,
  selectedItem: undefined,
  filterOptions: {
    rangeDate: [moment().startOf("month"), moment()],
    status: undefined,
  },
  request: undefined,
};

const myTicketsSlice = createSlice({
  name: "myTickets",
  initialState,
  reducers: {
    rxStartFetching: (state) => {
      state.isFetching = true;
    },
    rxSuccessFetchingData: (state, { payload }: PayloadAction<Ticket[]>) => {
      state.isFetching = false;
      state.data = payload;
      state.error = undefined;
      if (state.selectedItem) {
        const foundSelected = payload.find((e) => e.idTicket === state.selectedItem!.idTicket);
        if (!foundSelected) {
          state.selectedItem = undefined;
        } else {
          state.selectedItem = foundSelected;
        }
      }
    },
    rxErrorFetchingData: (state, { payload }: PayloadAction<string>) => {
      state.isFetching = false;
      state.data = [];
      state.error = payload;
    },
    rxSetFilterOptions: (state, { payload }: PayloadAction<FilterOptionsMyTickets>) => {
      state.filterOptions = payload;
    },
    rxSetRequest: (state, { payload }: PayloadAction<MyTicketsFilterRequest>) => {
      state.request = payload;
    },
    rxResetFilter: (state) => {
      state.filterOptions = {
        rangeDate: [moment().startOf("month"), moment()],
        status: undefined,
      };
    },
    rxSetSelectedTicket: (state, { payload }: PayloadAction<Ticket>) => {
      if (state.selectedItem) {
        state.selectedItem = state.selectedItem.idTicket === payload.idTicket ? undefined : payload;
      } else {
        state.selectedItem = payload;
      }
    },
  },
});

export const {
  rxErrorFetchingData,
  rxResetFilter,
  rxSetFilterOptions,
  rxSetRequest,
  rxSetSelectedTicket,
  rxStartFetching,
  rxSuccessFetchingData,
} = myTicketsSlice.actions;
export const myTicketsSelector = (state: { myTickets: MyTicketsState }) => state.myTickets;
export default myTicketsSlice.reducer;
